import { createSelector } from 'reselect';

import { MODULE_NAME } from '../constants';

import { State } from './reducer';

const getState = (state: { [MODULE_NAME]: State }) => state[MODULE_NAME];

export const selectCurrentSubscription = createSelector(getState, state => state.currentSubscription);

export const selectActiveBundles = createSelector(getState, state => state.activeBundles);

export const getTrialEligibility = createSelector(getState, state => state.trialEligibility);

export const selectIdempotencyKey = createSelector(getState, state => state.idempotencyKey);
